import { render, staticRenderFns } from "./ReportHistoryDialog.vue?vue&type=template&id=2184fed0&scoped=true"
import script from "./ReportHistoryDialog.vue?vue&type=script&lang=js"
export * from "./ReportHistoryDialog.vue?vue&type=script&lang=js"
import style0 from "./ReportHistoryDialog.vue?vue&type=style&index=0&id=2184fed0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2184fed0",
  null
  
)

export default component.exports